export default __webpack_public_path__ + "static/media/4.65bd3035.png";